module.exports = __webpack_public_path__ + "img/violet_016.f0e156e3.png";